import { useGetInvitesCount } from '../../../services/modules/invites/invites.queries';
import { useFeatureVisibility } from '../../permissions/contexts/FeatureVisibilityContext';
import { F } from '../../permissions/types/features.keys';
import { useAbility } from '../../users/AbilityContext';
import { canSeeInvites, canSeeReceived } from '../myNetworkUtils';

const usePendingInvitesCount = () => {
  const ability = useAbility();
  const { isVisible } = useFeatureVisibility();
  const isEnabled =
    canSeeReceived(ability) && canSeeInvites(ability) && isVisible(F.menu.connections);
  const { data } = useGetInvitesCount({ enabled: isEnabled, refetchOnWindowFocus: true });

  return isEnabled ? (data?.RECEIVED ?? 0) : 0;
};

export default usePendingInvitesCount;
